import React, { useContext, useEffect, useRef, useState } from "react";
import moment from "moment";
import { isEmpty, startCase } from "lodash";

import MyAccountLayout from "./MyAccountLayout";
import CustomDatePicker from "../../components/CustomDatePicker";
import MyAccountFilter from "./MyAccountFilter";
import { apiGet } from "../../Utils/apiFetch";
import { apiPath } from "../../Utils/apiPath";
import { formatDate, toFixedWithoutRounding } from "../../Utils/Constant";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import Pagination from "../../components/Pagination";
import { useParams } from "react-router-dom";

const TABS = [
  { key: "Exchange", label: "Exchange", betType: "betfair" },
  // { key: "FancyBet", label: "FancyBet", betType: "fancy" },
  // { key: "Sportsbook", label: "Sportsbook", betType: "sportBook" },
  // { key: "BookMaker", label: "BookMaker", betType: "bookmaker" },
  // { key: "Casino", label: "Casino", betType: "casino" },
  // { key: "parlay", label: "Parlay", betType: "parlay" },
];

const BettingHistory = () => {
  const params = useParams();
  const DEFAULT_FILTER = {
    page: 1,
    limit: 10,
    betType: "all",
    status: "completed",
    userType: params.type,
    id: params.id,
    fromPeriod: moment().subtract(1, "day").format("YYYY-MM-DD HH:mm:ss"),
    toPeriod: moment().format("YYYY-MM-DD HH:mm:ss"),
  };
  const tableRef = useRef();
  const user = useContextSelector(AuthContext, (ctx) => ctx.user);

  const [activeTab, setActiveTab] = useState("Exchange");
  const [data, setData] = useState([]);
  const [openRows, setOpenRows] = useState({}); // { [rowId]: boolean } — expand/collapse state
  const [filter, setFilter] = useState(DEFAULT_FILTER);

  const getData = async (activeFilter) => {
    const { status, data: response_users } = await apiGet(
      apiPath.betHistory,
      activeFilter,
    );
    if (status === 200) {
      if (status === 200 && response_users.success) {
        setData({ ...response_users.pagination, data: response_users.data });
      }
    }
  };

  useEffect(() => {
    getData(filter);
  }, [filter.type, filter.page, filter.limit, filter.betType]);

  const handleTypeChange = (tabKey) => {
    const tab = TABS.find((t) => t.key === tabKey) || TABS[0];
    setActiveTab(tabKey);
    setOpenRows({});
    setFilter((prev) => ({
      ...prev,
      type: tabKey,
      betType: tab.betType,
      page: 1, // reset page since the dataset changes with type
    }));
  };

  const handleBetTypeChange = (newBetType) => {
    setFilter((prev) => ({
      ...prev,
      betType: newBetType,
      page: 1, // reset page since the dataset changes with betType
    }));
  };

  const handleLimitChange = (e) => {
    setFilter((prev) => ({ ...prev, limit: Number(e.target.value), page: 1 }));
  };

  const handlePageChange = (newPage) => {
    setFilter((prev) => ({ ...prev, page: newPage }));
  };

  const handlePageClick = (event) => {
    handlePageChange(event.selected + 1);
  };

  const applyPreset = (preset) => {
    let fromPeriod, toPeriod;

    if (preset === "today") {
      fromPeriod = moment().startOf("day");
      toPeriod = moment().endOf("day");
    } else {
      fromPeriod = moment().subtract(1, "day").startOf("day");
      toPeriod = moment().subtract(1, "day").endOf("day");
    }

    const nextFilter = {
      ...filter,
      page: 1,
      fromPeriod: fromPeriod.format("YYYY-MM-DD HH:mm:ss"),
      toPeriod: toPeriod.format("YYYY-MM-DD HH:mm:ss"),
    };

    setFilter(nextFilter);
    if (filter.page === nextFilter.page) getData(nextFilter);
  };

  const handleShowDefault = () => {
    setFilter(DEFAULT_FILTER);
    getData(DEFAULT_FILTER);
  };

  const toggleRow = (e, id) => {
    setOpenRows((prev) => ({ ...prev, [id]: !prev[id] }));
    e.currentTarget.className = openRows[id]
      ? "fas fa-plus-square"
      : "fas fa-minus-square pe-2";
  };

  const currentBetType = filter.betType;
  const rows =
    currentBetType === "casino" || currentBetType === "parlay"
      ? data?.data || data || []
      : data?.data || [];
  /* ------------------------------- P/L totals ------------------------------- */

  const getWin = (item) => {
  if (item?.exchangeType == "session") {
    return item?.type === "No"
      ? item?.decisionRun < item?.betRun
      : item?.decisionRun >= item?.betRun;
  }
  if (item?.exchangeType == "sportbook") {
    return (item?.teamSelectionWin || "")
      .split(",")
      .includes(item?.fancySelectionId);
  }
  return !!item?.isWin; // last branch, see note below
};

const getPL = (item) => {
  if (item?.status === "voided") return 0;
  return getWin(item)
    ? Number(item?.profitAmount) || 0
    : -(Number(item?.loseAmount) || 0);
};

const totalPL = (data?.data || []).reduce((sum, item) => sum + getPL(item), 0);
  return (
    <MyAccountLayout>
      <div id="report" className="col-center report">
        <div className="box" style={{ alignItems: "baseline" }}>
          <h3
            style={{
              fontSize: "24px",
              marginTop: "20px",
              marginBottom: "10px",
            }}
          >
            Betting History
          </h3>
          <div className="push" />
        </div>

        {/* Tabs */}
        <ul className="report-tab-wrap" style={{ display: "block" }}>
          {TABS.map((tab) => (
            <li
              key={tab.key}
              id={`reportType_${tab.betType}`}
              className={`report-tab ${activeTab === tab.key ? "select" : ""}`}
              style={{ cursor: "pointer" }}
              onClick={() => handleTypeChange(tab.key)}
            >
              {tab.label}
            </li>
          ))}
        </ul>

        {/* Filters */}
        <div className="function-wrap">
          <ul className="input-list">
            <div id="statusCondition">
              <li>
                <label>Bet Status:</label>
              </li>
              <li>
                <select
                  name="betStatus"
                  id="betStatus"
                  value={filter.status}
                  onChange={(e) =>
                    setFilter((prev) => ({
                      ...prev,
                      status: e.target.value,
                      page: 1,
                    }))
                  }
                >
                  <option value="">All</option>
                  <option value="completed">Settled</option>
                  <option value="cancelled">Cancelled</option>
                  <option value="voided">Voided</option>
                </select>
              </li>
            </div>

            <li>
              <label>Period</label>
            </li>
            <CustomDatePicker filter={filter} setFilter={setFilter} />
          </ul>

          <ul className="input-list flowroot">
            <li>
              <a
                id="today"
                className="btn"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  applyPreset("today");
                }}
              >
                Just for today
              </a>
            </li>
            <li>
              <a
                id="yesterday"
                className="btn"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  applyPreset("yesterday");
                }}
              >
                From yesterday
              </a>
            </li>
            <li>
              <a
                id="getPL"
                className="btn-send"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  getData(filter);
                }}
              >
                Get P &amp; L
              </a>
            </li>
            {/* <li>
              <a
                id="resetFilter"
                className="btn"
                href="#"
                onClick={(e) => {
                  e.preventDefault();
                  handleShowDefault();
                }}
              >
                Reset
              </a>
            </li> */}
          </ul>
        </div>

        {/* Totals + limit selector */}
        <div id="userTreeDiv" className="total_all">
          <div
            style={{
              padding: "4px 12px",
              fontWeight: "bold",
              fontSize: "16px",
            }}
          >
            Total P/L:&nbsp;
            <span className={totalPL < 0 ? "red" : "green"}>
              ({toFixedWithoutRounding(totalPL)})
            </span>
          </div>
          <span className="spacer" />
          <span>
            <label>Last:</label>
            <select
              name="limit"
              id="limit"
              value={filter.limit}
              onChange={handleLimitChange}
            >
               <option value={10}>10 Txn</option>{" "}
              <option value={25}>25 Txn</option>{" "}
              <option value={50}>50 Txn</option>
              <option value={100}>100 Txn</option>
            </select>
          </span>
          <MyAccountFilter
            type={"new"}
            tableRef={tableRef}
            fileName={"betting-history"}
          />
        </div>

        {/* Table */}
        <div id="reportTable">
          <div
            className="table-responsive data-table"
            style={{ overflow: "auto", whiteSpace: "nowrap" }}
          >
            {currentBetType === "casino" ? (
              <CasinoTable
                rows={rows}
                tableRef={tableRef}
                user={user}
                openRows={openRows}
                toggleRow={toggleRow}
              />
            ) : currentBetType === "parlay" ? (
              <ParlayTable
                rows={rows}
                tableRef={tableRef}
                openRows={openRows}
                toggleRow={toggleRow}
              />
            ) : (
              <DefaultTable
                rows={rows}
                tableRef={tableRef}
                user={user}
                betType={currentBetType}
                openRows={openRows}
                toggleRow={toggleRow}
              />
            )}
          </div>
          <div className="bottom-pagination">
            {data?.data?.length > 0 && data?.totalRecords > 0 && (
              <Pagination pagination={data} onPageChange={handlePageChange} />
            )}
          </div>
        </div>
      </div>
    </MyAccountLayout>
  );
};

/* ------------------------------------------------------------------------ */
/*  Default table: Exchange / FancyBet / Sportsbook / BookMaker / Toss / Tie */
/* ------------------------------------------------------------------------ */
function DefaultTable({ rows, tableRef, user, betType, openRows, toggleRow }) {
  return (
    <table
      ref={tableRef}
      id="table_DL"
      className="table-s"
      style={{ display: "table" }}
    >
      <tbody>
        <tr>
          <th width="15%" data-name="betId" className="align-L sort_asc">
            Bet ID
          </th>
          <th width="9%" data-name="userName" className="align-L sort_asc">
            PL ID
          </th>
          <th data-name="eventName" className="align-L sort_asc">
            Market
          </th>
          <th width="12%" data-name="selName" className="sort_asc">
            Selection
          </th>
          <th width="4%" data-name="betType" className="sort_asc">
            Type
          </th>
          <th width="8%" data-name="betTime" className="sort_asc">
            Bet Placed
          </th>
          <th width="7%" data-name="odds" className="sort_asc">
            Odds
          </th>
          <th width="8%" data-name="stake" className="sort_asc">
            Stake
          </th>
          <th width="10%" data-name="PL" className="sort_asc">
            Profit/Loss
          </th>
          <th width="10%" id="userCancelTitle">
            Status
          </th>
        </tr>

        {rows && rows.length > 0 ? (
          rows.map((item, index) => {
            const rowId =
              item?.matchBetId || item?.sessionBetId || item?._id || index;
            const subId = `sub_${rowId}`;
            const isOpen = !!openRows[subId];

            const isWin =
              (item?.teamSelectionWin === item?.selectionId &&
                item?.betType === "back") ||
              (item?.teamSelectionWin !== item?.selectionId &&
                item?.betType === "lay");

            return (
              <React.Fragment key={rowId}>
                <tr style={{ display: "table-row" }}>
                  <td className="align-L">
                    <a
                      onClick={(e) => toggleRow(e, subId)}
                      className={isOpen ? "expand-close" : "expand-open"}
                    >
                      {item?.exchangeType === "session"
                        ? item?.sessionBetId
                        : item?.matchBetId || "N/A"}
                    </a>
                  </td>
                  <td className="align-L">{item?.clientName || "-"}</td>
                  <td className="align-L">
                    {`${
                      item?.eventType === "4"
                        ? "Cricket"
                        : item?.eventType === "1"
                          ? "Soccer"
                          : item?.eventType === "2"
                            ? "Tennis"
                            : "Sports"
                    }`}
                    <img
                      src="/assets/images/transparent.gif"
                      className="fromto"
                      alt=""
                    />
                    <strong>{item?.matchName}</strong>
                    <img
                      src="/assets/images/transparent.gif"
                      className="fromto"
                      alt=""
                    />
                    {item?.exchangeType == "sportbook" ||
                    item?.exchangeType === "session"
                      ? item?.fancyName
                      : betType === "bookmaker"
                        ? "Bookmaker"
                        : "Match Odds"}
                  </td>
                  <td>
                    {item?.exchangeType === "session"
                      ? `${item?.betRun}/${item?.bhav}`
                      : item?.exchangeType == "sportbook"
                        ? item?.runnerName
                        : item?.teamName}
                  </td>
                  <td>
                    <span className={item?.betType === "lay" ? "lay" : "back"}>
                      {startCase(
                        item?.exchangeType === "session"
                          ? item?.type
                          : item?.betType,
                      ) || "N/A"}
                    </span>
                  </td>
                  <td>
                    <span className="small-date">
                      {formatDate(item?.timeInserted, user?.timeZone)}
                    </span>
                  </td>
                  <td>{toFixedWithoutRounding(item?.bhav) || "N/A"}</td>
                  <td>{item?.amount || "N/A"}</td>
                  <td>
                    {item?.status !== "voided" ? (
                      item?.exchangeType == "session" ? (
                        item?.type === "No" ? (
                          item?.decisionRun < item?.betRun ? (
                            <span className="green">{item?.profitAmount}</span>
                          ) : (
                            <span className="red">-{item?.loseAmount}</span>
                          )
                        ) : item?.decisionRun >= item?.betRun ? (
                          <span className="green">{item?.profitAmount}</span>
                        ) : (
                          <span className="red">-{item?.loseAmount}</span>
                        )
                      ) : item?.exchangeType == "sportbook" ? (
                        item?.teamSelectionWin
                          ?.split(",")
                          .includes(item?.fancySelectionId) ? (
                          <span className="green">{item?.profitAmount}</span>
                        ) : (
                          <span className="red">-{item?.loseAmount}</span>
                        )
                      ) : isWin ? (
                        <span className="green">{item?.profitAmount}</span>
                      ) : (
                        <span className="red">-{item?.loseAmount}</span>
                      )
                    ) : (
                      <span>0.00</span>
                    )}
                  </td>
                  <td className="align-L link-cell">
                    {startCase(item?.status)}
                  </td>
                </tr>

                <tr
                  className="expand"
                  id={subId}
                  style={{ display: isOpen ? "table-row" : "none" }}
                >
                  <td colSpan={2} />
                  <td colSpan={8}>
                    <img
                      src="/assets/images/transparent.gif"
                      className="expand-arrow"
                      alt=""
                    />
                    <table id={`txTable_${rowId}`}>
                      <tbody>
                        <tr>
                          <th>Bet taken</th>
                          <th width="16%">Odds</th>
                          <th width="17%">Stake</th>
                          <th width="24%">Profit/Loss</th>
                        </tr>
                        <tr className="even" style={{ display: "table-row" }}>
                          <td>
                            <span className="small-date">
                              {formatDate(item?.timeInserted, user?.timeZone)}
                            </span>
                          </td>
                          <td>{toFixedWithoutRounding(item?.bhav) || "N/A"}</td>
                          <td>{item?.amount || "N/A"}</td>
                          <td>
                            {item?.status !== "voided" ? (
                              isWin ? (
                                <span className="green">
                                  {item?.profitAmount}
                                </span>
                              ) : (
                                <span className="red">
                                  -({item?.loseAmount})
                                </span>
                              )
                            ) : (
                              "0.00"
                            )}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </React.Fragment>
            );
          })
        ) : (
          <tr>
            <td colSpan={10}>You have no bets in this time period.</td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

/* ------------------------------------------------------------------------ */
/*  Casino table                                                            */
/* ------------------------------------------------------------------------ */
function CasinoTable({ rows, tableRef, user, openRows, toggleRow }) {
  return (
    <table
      ref={tableRef}
      id="table_DL"
      className="table-s"
      style={{ display: "table" }}
    >
      <tbody>
        <tr>
          <th width="15%" className="align-L sort_asc">
            Bet ID
          </th>
          <th width="9%" className="align-L sort_asc">
            PL ID
          </th>
          <th className="align-L sort_asc">Market</th>
          <th width="8%" className="sort_asc">
            Bet Placed
          </th>
          <th width="8%" className="sort_asc">
            Stake
          </th>
          <th width="10%" className="sort_asc">
            Profit/Loss
          </th>
        </tr>

        {rows && rows.length > 0 ? (
          rows.map((item, index) => {
            const subId = `sub_${item?.platformTxId || index}`;
            const isOpen = !!openRows[subId];
            const pl = item?.transactions?.realCutAmount;

            return (
              <React.Fragment key={item?.platformTxId || index}>
                <tr style={{ display: "table-row" }}>
                  <td className="align-L">
                    <a
                      onClick={(e) => toggleRow(e, subId)}
                      className={isOpen ? "expand-close" : "expand-open"}
                    >
                      {item?.platformTxId}
                    </a>
                  </td>
                  <td className="align-L">{item?.clientName}</td>
                  <td className="align-L">
                    Casino
                    <img
                      src="/assets/images/transparent.gif"
                      className="fromto"
                      alt=""
                    />
                    <strong> {item?.casinoName}</strong>
                    <img
                      src="/assets/images/transparent.gif"
                      className="fromto"
                      alt=""
                    />
                    {item?.gameCode}
                  </td>
                  <td>
                    <span className="small-date">
                      {formatDate(item?.timeInserted, user?.timeZone)}
                    </span>
                  </td>
                  <td>{item?.betAmount}</td>
                  <td>
                    {Math.sign(pl) === -1 ? (
                      <span className="red">
                        ({toFixedWithoutRounding(pl)})
                      </span>
                    ) : (
                      <span className="green">
                        ({toFixedWithoutRounding(Math.abs(pl))})
                      </span>
                    )}
                  </td>
                </tr>

                <tr
                  className="expand"
                  id={subId}
                  style={{ display: isOpen ? "table-row" : "none" }}
                >
                  <td colSpan={1} />
                  <td colSpan={5}>
                    <img
                      src="/assets/images/transparent.gif"
                      className="expand-arrow"
                      alt=""
                    />
                    <table>
                      <tbody>
                        <tr>
                          <th>Bet Taken</th>
                          <th>Odds Req.</th>
                          <th>Stake</th>
                          <th>Liability</th>
                        </tr>
                        <tr className="even" style={{ display: "table-row" }}>
                          <td>
                            {formatDate(item?.timeInserted, user?.timeZone)}
                          </td>
                          <td>0.00</td>
                          <td>{item?.betAmount}</td>
                          <td>{item?.loseAmount ? item?.loseAmount : "-"}</td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>
              </React.Fragment>
            );
          })
        ) : (
          <tr>
            <td colSpan={6}>You have no bets in this time period.</td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

/* ------------------------------------------------------------------------ */
/*  Parlay table                                                            */
/* ------------------------------------------------------------------------ */
function ParlayTable({ rows, tableRef, openRows, toggleRow }) {
  return (
    <table
      ref={tableRef}
      id="table_DL"
      className="table-s"
      style={{ display: "table" }}
    >
      <tbody>
        <tr>
          <th className="align-L sort_asc">Market</th>
          <th className="sort_asc">Settled Date</th>
          <th className="sort_asc">Bet ID</th>
          <th className="sort_asc">Stake</th>
          <th className="sort_asc">Profit/Loss</th>
        </tr>

        {rows && rows.length > 0 ? (
          rows.map((item, index) => {
            const subId = `sub_${item?._id || index}`;
            const isOpen = !!openRows[subId];
            const legLabel =
              item?.bets?.length === 1
                ? "SINGLE"
                : item?.bets?.length === 2
                  ? "DOUBLE"
                  : item?.bets?.length === 3
                    ? "TREBLE"
                    : item?.bets?.length > 3
                      ? "ACCUMULATOR"
                      : "";

            return (
              <React.Fragment key={item?._id || index}>
                <tr style={{ display: "table-row" }}>
                  <td className="align-L">
                    {item?.isDeclared ? (
                      <strong
                        className={item?.result === "loss" ? "red" : "green"}
                      >
                        {startCase(item?.result)}
                      </strong>
                    ) : (
                      "..."
                    )}
                    <img
                      src="/assets/images/transparent.gif"
                      className="fromto"
                      alt=""
                    />
                    <strong>{legLabel}</strong>
                  </td>
                  <td>{formatDate(item?.timeInserted)}</td>
                  <td>{item?.matchBetId}</td>
                  <td>{item?.amount}</td>
                  <td>
                    {item?.isDeclared ? (
                      item?.result === "loss" ? (
                        <strong className="red">
                          {toFixedWithoutRounding(item?.loseAmount)}
                        </strong>
                      ) : (
                        <strong className="green">
                          {toFixedWithoutRounding(item?.profitAmount)}
                        </strong>
                      )
                    ) : (
                      "..."
                    )}
                    {item?.bets?.length > 0 && (
                      <i
                        className={
                          isOpen
                            ? "fas fa-minus-square pe-2"
                            : "fas fa-plus-square pe-2"
                        }
                        style={{ marginLeft: "6px", cursor: "pointer" }}
                        onClick={(e) => toggleRow(e, subId)}
                      />
                    )}
                  </td>
                </tr>

                {item?.bets?.length > 0 && (
                  <tr
                    className="expand"
                    id={subId}
                    style={{ display: isOpen ? "table-row" : "none" }}
                  >
                    <td colSpan={5}>
                      <table>
                        <tbody>
                          <tr>
                            <th className="align-L">Fancy Name</th>
                            <th>Selection</th>
                            <th>Odds</th>
                            <th>Profit/Loss</th>
                          </tr>
                          {item.bets.map((betData, i) => (
                            <tr
                              key={i}
                              className="even"
                              style={{ display: "table-row" }}
                            >
                              <td>{betData?.fancyName}</td>
                              <td>{betData?.runnerName}</td>
                              <td>{toFixedWithoutRounding(betData?.bhav)}</td>
                              <td>
                                {betData?.isDeclared ? (
                                  <strong
                                    className={
                                      betData?.result === "loss"
                                        ? "red"
                                        : "green"
                                    }
                                  >
                                    {startCase(betData?.result)}
                                  </strong>
                                ) : (
                                  "..."
                                )}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                )}
              </React.Fragment>
            );
          })
        ) : (
          <tr>
            <td colSpan={5}>You have no bets in this time period.</td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

export default BettingHistory;
